import axios from 'axios';
import {API} from '../config';

function normalizeAxiosError(err) {
	if (!err || !err.response) {
		return {
			isSuccess: false,
			status: 0,
			code: "NETWORK_ERROR",
			message: "네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
			detail: null,
			raw: err,
		};
	}
	const { status, data } = err.response;

	const statusMsg =
		status === 404
		? "존재하지 않는 요청입니다. 확인해주세요."
		: status === 401
		? "로그인이 필요합니다."
		: status === 403
		? "접근 권한이 없습니다."
		: status >= 500
		? "서버 에러입니다. 지속적으로 발생 시 문의 전화 주세요."
		: null;

	let message = statusMsg;
	if (!message) {
		if (typeof data === "string") message = data;
		else if (data?.detail) message = data.detail;
	}

	const fieldMessages = [];
	if (data && typeof data === "object" && !Array.isArray(data)) {
		for (const [k, v] of Object.entries(data)) {
		if (k === "detail") continue;
		if (Array.isArray(v)) v.forEach((x) => fieldMessages.push(`${k}: ${typeof x === "string" ? x : JSON.stringify(x)}`));
		else if (typeof v === "string") fieldMessages.push(`${k}: ${v}`);
		}
	}

	if (!message && fieldMessages.length) {
		message = fieldMessages.join("\n");
	}

	return {
		isSuccess: false,
		status,
		code: data?.code || null,
		message: message || "요청을 처리할 수 없습니다. 입력값을 확인해주세요.",
		detail: fieldMessages.length ? fieldMessages : null,
		raw: err,
	};
}

const getCookie = (name) => {
	const value = document.cookie
		.split('; ')
		.find((row) => row.startsWith(name + '='));
	return value ? decodeURIComponent(value.split('=')[1]) : null;
};

export const defaultApi = async ({
	data,
	params,
	url,
	method,
	isRaw = false,
	responseType,
	headers,
}) => {
	const csrfToken = getCookie('csrftoken');
	try {
		let res = await axios({
			method,
			url: `${API}${url}`,
			data,
			params,
			responseType,
			withCredentials: true,
			headers: {
				...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
				...headers,
			},
		});
		if (isRaw) {
			return res;
		}
		return {isSuccess: true, status: res.status, data: res.data};
	} catch (err) {
		const normalized = normalizeAxiosError(err);
		return normalized;
	}
};

export const getListBoardNotice = async ({category, page, ordering, search, lang}) => {
	let params = {
		category,
		page,
		ordering,
		search,
		lang,
	};

	return await defaultApi({params, url: `/api/boards/notices/`, method: 'GET'});
};

export const getListBoardPortfolio = async ({category, page, ordering, search, lang}) => {
	let params = {
		category,
		page,
		ordering,
		search,
		lang,
	};

	return await defaultApi({params, url: `/api/boards/portfolios/`, method: 'GET'});
};

export const getListBoardRelease = async ({category, page, ordering, search, lang}) => {
	let params = {
		category,
		page,
		ordering,
		search,
		lang,
	};

	return await defaultApi({params, url: `/api/boards/releases/`, method: 'GET'});
};

export const getNotice = async ({id}) => {
	let params = {
	};

	return await defaultApi({params, url: `/api/boards/notices/${id}/`, method: 'GET'});
};

export const getPortfolio = async ({id}) => {
	let params = {
	};

	return await defaultApi({params, url: `/api/boards/portfolios/${id}/`, method: 'GET'});
};

export const getRelease = async ({id}) => {
	let params = {
	};

	return await defaultApi({params, url: `/api/boards/releases/${id}/`, method: 'GET'});
};

export const getCategories = async () => {
	let params = {
	};

	return await defaultApi({params, url: `/api/products/categories/`, method: 'GET'});
};

export const getListProduct = async ({category, page, ordering, search, lang}) => {
	let params = {
		category,
		page,
		ordering,
		search,
		lang,
	};

	return await defaultApi({params, url: `/api/products/`, method: 'GET'});
};

export const getProduct = async ({id}) => {
	let params = {
	};

	return await defaultApi({params, url: `/api/products/${id}/`, method: 'GET'});
};

export const getListMainNotice = async () => {
	let params = {
	};

	return await defaultApi({params, url: `/api/boards/main/`, method: 'GET'});
};

export const getPopup = async () => {
	let params = {
	};

	return await defaultApi({params, url: `/api/displays/popup/`, method: 'GET'});
};

export const postContact = async ({
	company,
	name,
	phone,
	email,
	inquiry,
	title,
	content,
	file,
}) => {
	let data = {
		company,
		name,
		phone,
		email,
		inquiry,
		title,
		content,
		file,
	};
	return await defaultApi({
		data,
		url: '/api/boards/contact/',
		method: 'POST',
	});
};
